var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-card"},[_c('div',{staticClass:"list-card-container"},[_c('div',{class:['img-container', _vm.position]},[_c('div',{staticClass:"img",style:({ backgroundImage: `url(${_vm.src})` })})]),_c('div',{class:['content', _vm.position]},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }